import { VNode, h } from 'virtual-dom';
import { Store } from "redux";
import { hideEndChatWarningAction } from "../actions/actions";
import { AlmeState } from '../../../../wireup/AlmeState';
import { EndChatWarningOverlayDefaultSettings } from '../settings/default';
import LiveChatState from '../../../livechat-foundation/src/livechat-state';

export default class Renderer {
    //#region Public Interface
    _settings: EndChatWarningOverlayDefaultSettings;
    _state: LiveChatState;
    public _store: Store<AlmeState> | undefined;

    constructor(passedSettings: EndChatWarningOverlayDefaultSettings, state: LiveChatState) {
        this._settings = passedSettings;
        this._state = state;
    }

    public initialize(store: Store<AlmeState>): void {
        this._store = store;
    }

    public getRender() {
        return (): VNode => {
            return this.buildWarning();
        };
    }

    //#endregion

    //#region Builder Methods

    buildWarning(): VNode {
        const warningClassName = this._settings.classNames.livechat.endChatWarning;
        const padClassName = this._settings.classNames.livechat.endChatWarningPad;
        const shadowClassName = this._settings.classNames.livechat.endChatWarningShadow;
        const textId = this._settings.elementIds.endChatWarningTextId;

        const children =
            [
                this.buildText(),
                this.buildButtonWrapper(),
            ];

        const warningAttributes =
        {
            className: warningClassName,
            attributes: {
                role: 'dialog',
                'aria-labelledby': textId,
                'aria-modal': 'true',
            },
        };

        const warning = h("div", warningAttributes, children);
        const pad = h("div", { className: padClassName }, [warning]);

        return h("div", { className: shadowClassName }, [pad]);
    }

    buildText(): VNode {
        const textClass = this._settings.classNames.livechat.endChatWarningText;
        const textId = this._settings.elementIds.endChatWarningTextId;
        const text = this._settings.textConstants.endChatWarningText;

        return h("span", { className: textClass, id: textId }, [text]);
    }

    buildButtonWrapper(): VNode {
        const buttonWrapClass = this._settings.classNames.livechat.endChatWarningButtonWrap;
        return h("div", { className: buttonWrapClass }, [this.buildYesButton(), this.buildNoButton()]);
    }

    buildYesButton(): VNode {
        const visibleLocation = `${this._settings.stateLocations.EndChatWarning.Base}.${this._settings.stateLocations.EndChatWarning.Visible}`;
        const className = this._settings.classNames.livechat.endChatWarningYesButton;
        const title = this._settings.textConstants.endChatWarningYesTitle;
        const properties =
        {
            className: className,
            onclick: (): void => {
                this._store?.dispatch(hideEndChatWarningAction(visibleLocation));
                this._state.endChat('User', 'Click');
            },
        };

        return h("button", properties, title);
    }

    buildNoButton(): VNode {
        const visibleLocation = `${this._settings.stateLocations.EndChatWarning.Base}.${this._settings.stateLocations.EndChatWarning.Visible}`;
        const className = this._settings.classNames.livechat.endChatWarningNoButton;
        const title = this._settings.textConstants.endChatWarningNoTitle;
        const properties =
        {
            className: className,
            onclick: (): void => {
                this._store?.dispatch(hideEndChatWarningAction(visibleLocation));
            },
        };

        return h("button", properties, title);
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-endchat-warning-overlay/src/renderers/renderer.ts